import { createSlice } from "@reduxjs/toolkit";

export const ACTION_TYPES = {
  SET_AUTO_REDIRECT_TO_NIAS: 'KeycloakState/SET_AUTO_REDIRECT_TO_NIAS',
};

const initialState = {
  autoRedirectToNias: false,
  forceNiasLogin: false
};

export type KeycloakState = Readonly<typeof initialState>;

export const KeycloakSlice = createSlice({
  name: 'keycloakSlice',
  initialState: initialState as KeycloakState,
  reducers: {
    setAutoRedirectToNias(state, action) {
      return {
        ...state,
        autoRedirectToNias: action.payload.autoRedirectToNias,
      }
    },
    setForceNiasLogin(state) {
      return {
        ...state,
        forceNiasLogin: true
      }
    },
  },
});

export const { setAutoRedirectToNias, setForceNiasLogin } = KeycloakSlice.actions;
export default KeycloakSlice.reducer;
